var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('header',[_c('h1',[_vm._t("default")],2),(_setup.canClose)?_c('button',{staticClass:"close-button-modal",on:{"click":_setup.close}},[_c('img',{attrs:{"src":require("@/assets/img/icons-contracts/modal-header.svg"),"alt":"modal-header"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }